var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-detail"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.detail.year)+"-"+_vm._s(_vm.detail.date))]),_c('div',{staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }